<template>
  <v-app-bar>
    <v-toolbar-title>
      <router-link id="routeToDashboard" :to="{ name: 'dashboard' }"
        ><img
          :src="require('@/assets/fplogo-iab.png')"
          alt="FP LOGO"
          style="padding-top: 10px" /></router-link
    ></v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="my-2">
      <router-link id="routeToPlanning" :to="{ name: 'planning' }">
        <v-btn
          color="primary"
          text
          class="text-capitalize"
          style="margin: 0 auto"
          ><v-icon left>mdi-arrow-up-bold-circle-outline</v-icon
          >{{ $cmsService.getContent(content, 'production_planning') }}</v-btn
        >
      </router-link>
      <router-link id="routeToReports" :to="{ name: 'reports' }">
        <v-btn
          color="primary"
          text
          class="text-capitalize"
          style="margin: 0 auto"
          ><v-icon left>mdi-chart-bar</v-icon
          >{{ $cmsService.getContent(content, 'reports') }}</v-btn
        >
      </router-link>
      <router-link id="routeToOneProcess" :to="{ name: 'oneProcess' }">
        <v-btn
          color="primary"
          text
          class="text-capitalize"
          style="margin: 0 auto"
          ><v-icon left>mdi-laptop</v-icon
          >{{ $cmsService.getContent(content, 'oneProcess') }}</v-btn
        >
      </router-link>
      <router-link
        id="routeToPartialBatchesPlanning"
        class="d-none"
        :to="{ name: 'partialBatchesPlanning' }"
      >
        <v-btn
          color="primary"
          text
          class="text-capitalize"
          style="margin: 0 auto"
          ><v-icon left>mdi-call-split</v-icon
          >{{
            $cmsService.getContent(content, 'partial_batches_planning')
          }}</v-btn
        >
      </router-link>
      <router-link
        id="routeToRemainingDocuments"
        class="d-none"
        :to="{ name: 'remainingDocuments' }"
      >
        <v-btn
          color="primary"
          text
          class="text-capitalize"
          style="margin: 0 auto"
          ><v-icon left>mdi-email-alert</v-icon
          >{{ $cmsService.getContent(content, 'remaining_Documents') }}</v-btn
        >
      </router-link>
      <!--
      <router-link id="routeToHistory" :to="{ name: 'history' }">
        <v-btn color="primary" text class="text-capitalize"
          ><v-icon left>mdi-history</v-icon>Produktionshistorie</v-btn
        >
      </router-link>
        -->
      <router-link v-if="showUsers" id="routeToUsers" :to="{ name: 'users' }">
        <v-btn to="/users" color="primary" text class="text-capitalize"
          ><v-icon light left>mdi-account</v-icon
          >{{ $cmsService.getContent(content, 'users') }}</v-btn
        >
      </router-link>
      <v-btn
        id="logout"
        color="primary"
        text
        class="text-capitalize"
        @click.stop="logout"
      >
        <v-icon left>mdi-power</v-icon
        >{{ $cmsService.getContent(content, 'logout') }}</v-btn
      >
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import headerJson from '@/data/json/header.json'
// import ContactModal from '@/components/ContactModal'
export default {
  name: 'HeaderLoggedIn',
  data() {
    return {
      content: headerJson.data,
      showModal: false,
      showUsers: this.$store.getters.isAdmin
    }
  },
  // components: { ContactModal },
  methods: {
    ...mapActions(['logoutUser']),
    ...mapGetters(['isAdmin']),
    logout() {
      return this.logoutUser().then(() => {
        this.$router.push({ name: 'homepage' })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.v-app-bar {
  max-height: 64px;
  background-color: #fff !important;
  -webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.35);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.35);
  a {
    text-decoration: none;
  }
  .v-btn {
    height: 100% !important;
    .--active::before,
    &:before {
      display: none;
    }
    &:hover {
      color: #d9534f !important;
    }
  }
}
.v-btn {
  &:hover {
    .v-icon {
      font-size: 32px !important;
    }
  }
}
</style>
